import {merge} from 'lodash';
import EcdsForm from '../../../../ward/forms/ecds/ecdsForm';
import {Permissions} from '../../../../../store/reducers/user';
import {PATIENT_CONTEXT_TYPE} from '../../../../../util/patientContextUtil';
import EcsEmailModal from '../../../../ward/forms/ecsEmailModal';
import {ClerkingForm} from '../../../../ward/forms/clerkingED/clerking_form';
import SeeAndTreat from '../../../../ward/forms/seeAndTreat';
import {TriageForm} from '../../../../ward/forms/triage/triage_form';
import InlineFormVTE from '../../../../ward/forms/vte/vte';
import ClinicalCourse from '../../../../ward/forms/clinicalCourse';
import InjuryForm from '../../../../ward/forms/injury/injuryForm';
import FrailtyForm from '../../../../ward/forms/frailtyForm';
import {getConfig} from '../../../../../util/configUtil';
import PatientSafetyChecklist from '../../../../ward/forms/patientSafetyChecklist/patientSafetyChecklist';
import NursingAdmission from '../../../../ward/forms/plans/nursingAdmission';
import VerificationOfDeath from '../../../../ward/forms/verificationOfDeath';
import ReferralsForm from '../../../../ward/forms/referralsForm';
import BedRequestFormExternal from '../../../../ward/forms/csm/bedRequestFormExternal';
import Urinalysis from '../../../../ward/forms/urinalysis/urinalysis';
import Household from '../../../../ward/forms/household';
import PaediatricSafeguarding from '../../../../ward/forms/safeguarding/paediatricSafeguarding';
import Delirium from '../../../../ward/forms/delirium/delirium';
import Rockwood from '../../../../ward/forms/clinicalFrailtyScore/rockwood';
import PrescriptionForm from '../../../../ward/forms/prescription/prescriptionForm';
import FitnessForWorkForm from '../../../../ward/forms/fitnessForWorkForm';
import SepsisToolForm from '../../../../ward/sepsis/sepsisToolForm';
import ClinicalConclusion from '../../../../ward/forms/clinicalConclusion';
import NutritionScreen from '../../../../ward/forms/nutritionScreen';
import SmokingFormModal from '../../../../ward/inpatientForms/smokingForm';
import NonContactObsForm from '../../../../ward/forms/plans/nonContactObsForm';
import RapidAssessment from '../../../../ward/forms/rapidAssessment';
import DependencyMiniForm from '../../../../ward/forms/DependencyMiniForm';
import MedicalPlan from '../../../../ward/forms/plans/medicalPlan';
import NursingPlan from '../../../../ward/forms/plans/nursingPlan';
import TreatmentPlan from '../../../../ward/forms/plans/treatmentPlan';
import MedicationForm from '../../../../ward/forms/edau/medicationForm';
import NurseForm from '../../../../ward/forms/edau/nurseForm';
import CurrentClinicianForm from '../../../../ward/forms/clinicianForm/currentClinician/currentClinicianForm';
import AmbulanceHandoverForm from '../../../../ward/forms/clinicianForm/ambulanceHendover/ambulanceHandoverForm';
import SeniorReviewForm from '../../../../ward/forms/clinicianForm/seniorReview/seniorReviewForm';
import HandoverForm from '../../../../ward/forms/clinicianForm/handover/handoverForm';
import EdauDischarge from '../../../../ward/forms/edauDischarge';
import Discharge from '../../../../ward/forms/discharge/discharge';
import OffWardForm from '../../../../ward/forms/offWard/offWardForm';
import OxygenFormModal from '../../../../ward/inpatientForms/oxygenForm';
import IntendentManagementFormModal from '../../../../ward/inpatientForms/intendentManagementForm';
import CurrentClinicianIpModal from '../../../../ward/inpatientForms/currentClinicianIpForm';
import BoardRoundList from '../../../../ward/inpatientForms/boardRound/boardRoundList';
import InlineClerkingForm from '../../../../ward/forms/clerkings/clerking';
import BedRequestForm from '../../../../ward/forms/csm/bedRequestForm';
import CsmContactTime from '../../../../ward/forms/csm/csmContactTime';
import Observation from '../../../../ward/forms/observation/observation';
import {formIds} from './formsId';
import FrailtySDECForm from '../../../../ward/forms/frailtySDECForm';
import AbbeyPainScaleForm from '../../../../ward/forms/abbeyPainScaleForm';
import ReferralReviewForm from '../../../../ward/forms/referralReview/referralReviewForm';

const defaultOptions = {
    dialogWidth: 'md',
    dynamicTitle: false,
    isMultipleForm: false,
    dataPath: null,
    dataSaveDestination: 'piw', // 'piw', 'patientData'
    blockExit: false,
    showScore: false,
    scorePath: null,
};

const contextItem = (formData, context, formTitle, enabled = true, requiredPermission = [], excludePatientType = [], options = {}) => {
    const mergedOpt = merge({}, defaultOptions, options);

    return {
        id: formData.id,
        isMiniForm: formData.isMiniForm,
        context,
        formTitle,
        enabled,
        requiredPermission,
        excludePatientType,
        options: mergedOpt,
    };
};

/*
* IMPORTANT!
*
* All assessment forms (not the main form) also need to be added to the "agyle.assessments" collection
* on the db to be configured in the Assessment option in the Ward Management section of the Admin Page.
* */
const getFormData = (formId) => {
    return formIds.find(form => form.id === formId);
};

export const contextFormsList = [
    // Full forms
    contextItem(getFormData('ecds'),
        <EcdsForm/>, 'Emergency Care Data Set', true, [Permissions.AGYLE_IS_ECDS_ADMIN, Permissions.AGYLE_CAN_VIEW_ECDS], [PATIENT_CONTEXT_TYPE.EDAU, PATIENT_CONTEXT_TYPE.INPATIENT]),
    contextItem(getFormData('clerkingED'),
        <ClerkingForm/>, 'ED Clerking', true, [], [PATIENT_CONTEXT_TYPE.EDAU, PATIENT_CONTEXT_TYPE.INPATIENT]),
    contextItem(getFormData('triage'),
        <TriageForm/>, 'Triage', true, [], [PATIENT_CONTEXT_TYPE.EDAU, PATIENT_CONTEXT_TYPE.INPATIENT]),
    contextItem(getFormData('snt'),
        <SeeAndTreat/>, 'See and Treat', true, [], [PATIENT_CONTEXT_TYPE.EDAU, PATIENT_CONTEXT_TYPE.INPATIENT]),
    contextItem(getFormData('vte'),
        <InlineFormVTE/>, 'VTE', true, [], [PATIENT_CONTEXT_TYPE.EDAU, PATIENT_CONTEXT_TYPE.INPATIENT]),
    contextItem(getFormData('msgToGp'),
        <ClinicalCourse/>, 'Message To GP', true, [], [PATIENT_CONTEXT_TYPE.EDAU, PATIENT_CONTEXT_TYPE.INPATIENT], {dynamicTitle: true}),
    contextItem(getFormData('injury'),
        <InjuryForm/>, null, true, [], [PATIENT_CONTEXT_TYPE.EDAU, PATIENT_CONTEXT_TYPE.INPATIENT], {
            dynamicTitle: true,
            isMultipleForm: true,
            dataPath: 'studies.injury',
        }),
    contextItem(getFormData('frailtyHistory'),
        <FrailtyForm/>, 'Frailty - Social History', getConfig('frailtyAgyleMiniForm', false), [Permissions.AGYLE_CAN_VIEW_FRAILITY], [PATIENT_CONTEXT_TYPE.EDAU, PATIENT_CONTEXT_TYPE.INPATIENT]),
    contextItem(getFormData('aeAssessment'),
        <NonContactObsForm/>, 'NON - Contact Physical Health Observations Tool', getConfig('nonContactObsAvailable', false), [], [PATIENT_CONTEXT_TYPE.EDAU, PATIENT_CONTEXT_TYPE.INPATIENT]),
    contextItem(getFormData('safetyChecklist'),
        <PatientSafetyChecklist/>, getConfig('modules.map.customMap', false) ? 'ADMISSION and SAFETY CHECKLIST' : 'Patient Safety Checklist', true, [], [PATIENT_CONTEXT_TYPE.INPATIENT]),
    contextItem(getFormData('propertyList'),
        <NursingAdmission/>, 'Property List', getConfig('nursingAdmissionAvailable', false), [], []),
    contextItem(getFormData('vod'),
        <VerificationOfDeath/>, 'Verification of Death', getConfig('verificationOfDeathAgyleMiniForm', false), [Permissions.AGYLE_CAN_VERIFICATIONOFDEATH]),
     contextItem(getFormData('referralReview'),
        <ReferralReviewForm/>, 'Referral Review', getConfig('referralReviewForm', false)),
    contextItem(getFormData('specReferrals'),
        <ReferralsForm/>, 'Speciality Referral', true, [Permissions.AGYLE_CAN_VIEW_REFERRALS, Permissions.AGYLE_CAN_MANAGE_REFERRALS]),
    contextItem(getFormData('newBedRequest'),
        <BedRequestFormExternal/>, 'Bed Request', true, []),
    contextItem(getFormData('bedRequest'),
        <BedRequestForm/>, 'Bed Request', (!getConfig('modules.bedManagement.bedRequest')), []),
    contextItem(getFormData('urinalysis'),
        <Urinalysis/>, 'Urinalysis Assessment', true, [Permissions.AGYLE_CAN_VIEW_URINALYSIS, Permissions.AGYLE_CAN_ADD_URINALYSIS, Permissions.AGYLE_CAN_EDIT_URINALYSIS], [], {
            isMultipleForm: true,
            dataPath: 'urinalysis',
            dataSaveDestination: 'patientData',
        }),
    contextItem(getFormData('household'),
        <Household/>, 'Household', true, [Permissions.AGYLE_CAN_VIEW_HOUSEHOLD]),
    contextItem(getFormData('paedSafeguarding'),
        <PaediatricSafeguarding/>, 'Paediatric Checks & Level', true, [Permissions.AGYLE_CAN_VIEW_PAEDIATRIC_SAFEGUARDING, Permissions.AGYLE_CAN_MANAGE_PAEDIATRIC_SAFEGUARDING], [PATIENT_CONTEXT_TYPE.EDAU, PATIENT_CONTEXT_TYPE.INPATIENT], {
            isMultipleForm: true,
            dataPath: 'studies.paedSafeguarding',
        }),
    contextItem(getFormData('delirium'),
        <Delirium/>, '4AT Screening for Delirium and Cognitive Impairment', true, [Permissions.AGYLE_CAN_VIEW_PAEDIATRIC_SAFEGUARDING, Permissions.AGYLE_CAN_MANAGE_PAEDIATRIC_SAFEGUARDING], [PATIENT_CONTEXT_TYPE.EDAU, PATIENT_CONTEXT_TYPE.INPATIENT], {
            isMultipleForm: true,
            dataPath: 'studies.delirium',
            showScore: true,
            scorePath: 'totalScore',
        }),
    contextItem(getFormData('clinicalFrailtyScore'),
        <Rockwood/>, 'Clinical Frailty Score', true, [Permissions.AGYLE_CAN_VIEW_PAEDIATRIC_SAFEGUARDING, Permissions.AGYLE_CAN_MANAGE_PAEDIATRIC_SAFEGUARDING], [PATIENT_CONTEXT_TYPE.EDAU, PATIENT_CONTEXT_TYPE.INPATIENT], {
            isMultipleForm: true,
            dataPath: 'studies.rockwood',
            showScore: true,
            scorePath: 'scale.__code',
        }),
    contextItem(getFormData('prescription'),
        <PrescriptionForm/>, 'Prescription Form', true, [], [], {
            isMultipleForm: true,
            dataPath: 'studies.prescription',
            showScore: true,
            scorePath: 'values.printCount',
        }),
    contextItem(getFormData('fitnessForWork'),
        <FitnessForWorkForm/>, 'eMed3', getConfig('fitnessForWorkEnabled', false), [Permissions.AGYLE_CAN_MANAGE_EMED3], [], {
            isMultipleForm: true,
            dataPath: 'studies.fitnessForWork',
        }),
    contextItem(getFormData('sepsisTool'),
        <SepsisToolForm/>, 'SEPSIS Screening & Action Tool', true, [Permissions.AGYLE_CAN_MANAGE_SEPSIS, Permissions.AGYLE_CAN_VIEW_SEPSIS], [], {
            isMultipleForm: true,
            dataPath: 'sepsisTool',
            dataSaveDestination: 'patientData',
            blockExit: true,
        }),
    contextItem(getFormData('nutritionScreen'),
        <NutritionScreen/>, null, true, [Permissions.AGYLE_CAN_VIEW_NUTRITION, Permissions.AGYLE_CAN_MANAGE_NUTRTION], [], {
            dynamicTitle: true,
            isMultipleForm: true,
            dataPath: 'nutritionScreen',
            dataSaveDestination: 'patientData',
        }),
    contextItem(getFormData('edauDischarge'),
        <EdauDischarge/>, 'EDAU Departure Checklist', true, [Permissions.AGYLE_CAN_ONLY_DISCHARGE_EDAU], [PATIENT_CONTEXT_TYPE.ED, PATIENT_CONTEXT_TYPE.INPATIENT]),
    contextItem(getFormData('discharge'),
        <Discharge/>, 'Patient Discharge', true, [], []),
    contextItem(getFormData('obs'),
        <Observation/>, 'Observation', true, [Permissions.AGYLE_CAN_ENTER_OBSERVATIONS], [], {dynamicTitle: true}),
    contextItem(getFormData('neuroObs'),
        <Observation neuroObs/>, 'Neurological Observation', true, [Permissions.AGYLE_CAN_ENTER_OBSERVATIONS], []),
    contextItem(getFormData('frailtySDECForm'),
        <FrailtySDECForm/>, 'Frailty SDEC Comprehensive Geriatric Assessment', getConfig('frailtySDECForm', false), [], []),
   contextItem(getFormData('abbeyPainScaleForm'),
        <AbbeyPainScaleForm/>, 'Abbey Pain Score', getConfig('abbeyPainScaleEnabled', false), [], []),

    // IP Full Form
    contextItem(getFormData('boardRound'),
        <BoardRoundList/>, 'Board Round', true, [], [PATIENT_CONTEXT_TYPE.ED, PATIENT_CONTEXT_TYPE.TEMPORARY, PATIENT_CONTEXT_TYPE.FAST_REGISTRY]),
    contextItem(getFormData('clerkingIP'),
        <InlineClerkingForm/>, 'Clerking', true, [], [PATIENT_CONTEXT_TYPE.ED, PATIENT_CONTEXT_TYPE.TEMPORARY, PATIENT_CONTEXT_TYPE.FAST_REGISTRY]),

    // Mini forms
    contextItem(getFormData('ecdsEmail'),
        <EcsEmailModal/>, null, true, [Permissions.AGYLE_IS_ECDS_ADMIN], [PATIENT_CONTEXT_TYPE.EDAU, PATIENT_CONTEXT_TYPE.INPATIENT]),
    contextItem(getFormData('clinicalConclusion'),
        <ClinicalConclusion/>, 'Clinical Conclusion', true, [], [PATIENT_CONTEXT_TYPE.EDAU, PATIENT_CONTEXT_TYPE.INPATIENT]),
    contextItem(getFormData('smoking'),
        <SmokingFormModal/>, 'Smoking Status', true, [], []),
    contextItem(getFormData('rapidAssessment'),
        <RapidAssessment/>, 'Rapid Assessment', true, [Permissions.AGYLE_CAN_SET_CLINICIAN], []),
    contextItem(getFormData('dependency'),
        <DependencyMiniForm/>, 'Dependency', true, [], [PATIENT_CONTEXT_TYPE.EDAU, PATIENT_CONTEXT_TYPE.INPATIENT], {dialogWidth: 'sm'}),
    contextItem(getFormData('treatmentPlan'),
        <TreatmentPlan/>, 'Treatment Plan', getConfig('treatmentFormEnabled', false), [], [PATIENT_CONTEXT_TYPE.INPATIENT], {dialogWidth: 'sm'}),
    contextItem(getFormData('medicalPlan'),
        <MedicalPlan/>, 'Medical Plan', getConfig('nurseMedicalPlanAvailable', false), [], [PATIENT_CONTEXT_TYPE.INPATIENT], {dialogWidth: 'sm'}),
    contextItem(getFormData('nursingPlan'),
        <NursingPlan/>, 'Nursing Plan', getConfig('nurseMedicalPlanAvailable', false), [], [PATIENT_CONTEXT_TYPE.INPATIENT], {dialogWidth: 'sm'}),
    contextItem(getFormData('nursingChecklist'),
        <NurseForm/>, 'Nursing Checklist Questions', true, [], [PATIENT_CONTEXT_TYPE.ED, PATIENT_CONTEXT_TYPE.INPATIENT]),
    contextItem(getFormData('medicalChecklist'),
        <MedicationForm/>, 'Medical Checklist Questions', true, [], [PATIENT_CONTEXT_TYPE.ED, PATIENT_CONTEXT_TYPE.INPATIENT]),
    contextItem(getFormData('currentClinician'),
        <CurrentClinicianForm clinicianFormType="currentClinician"/>, 'Current Clinician', true, [], []),
    contextItem(getFormData('firstClinician'),
        <CurrentClinicianForm clinicianFormType="firstClinician"/>, 'First Clinician', true, [], []),
    contextItem(getFormData('currentNurse'),
        <CurrentClinicianForm clinicianFormType="currentNurse"/>, 'Current Nurse', true, [], []),
    contextItem(getFormData('ambulanceHandover'),
        <AmbulanceHandoverForm/>, 'Ambulance Handover', true, [], []),
    contextItem(getFormData('seniorReview'),
        <SeniorReviewForm/>, 'Senior Review', true, [], []),
    contextItem(getFormData('handover'),
        <HandoverForm/>, 'Handover', true, [], []),
    contextItem(getFormData('nurseHandover'),
        <HandoverForm nurseHandover/>, 'Nurse Handover', true, [], []),
    contextItem(getFormData('csm'),
        <CsmContactTime/>, 'CSM Contact Time', true, [], []),

    // IP Mini forms
    contextItem(getFormData('offWard'),
        <OffWardForm/>, 'Off Ward', true, [], [], {dialogWidth: 'sm'}),
    contextItem(getFormData('intendentManagement'),
        <IntendentManagementFormModal/>, 'Intendent Management', true, [], [], {dialogWidth: 'sm'}),
    contextItem(getFormData('currentNurseIP'),
        <CurrentClinicianForm clinicianFormType="currentNurseIP"/>, 'Nurse', true, [], []),
    contextItem(getFormData('currentClinicianIP'),
        <CurrentClinicianIpModal/>, 'Current Clinician', true, [], [], {dialogWidth: 'sm'}),
    contextItem(getFormData('oxygen'),
        <OxygenFormModal/>, 'Oxygen prescribing / Administration', true, [], []),
];